module.exports = __webpack_public_path__ + "img/logo-padding.2ea5d92d.svg";